import { combineReducers } from '@reduxjs/toolkit'

import { reducer as plans } from './plan'
import { reducer as temporaryPlan } from './temporaryPlan'
import { reducer as planDetail } from './planDetail'

export default combineReducers({ plans, temporaryPlan, planDetail })
